// app/javascript/controllers/hamburger_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "line1", "line2", "line3", "closeButton", "closeLine1", "closeLine2"]

  connect() {
    // 初期状態を確保
    this.isOpen = false
    this.reset()
    // 初期位置を設定
    this.menuTarget.style.transform = "translate(100%, -100%)"
  }

  toggle() {
    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.isOpen = true
    
    // 斜め右上から左下へスライドイン（アニメーション付き）
    this.menuTarget.style.transition = "transform 0.5s ease-in-out"
    this.menuTarget.style.transform = "translate(0%, 0%)"
    
    // ハンバーガーアイコンを×に変換
    this.line1Target.style.transform = "rotate(45deg) translate(6px, 6px)"
    this.line2Target.style.opacity = "0"
    this.line3Target.style.transform = "rotate(-45deg) translate(6px, -6px)"
    
    // bodyのスクロールを防ぐ
    document.body.style.overflow = 'hidden'
  }

  close() {
    this.isOpen = false
    
    // 斜め右上へスライドアウト（アニメーション付き）
    this.menuTarget.style.transition = "transform 0.5s ease-in-out"
    this.menuTarget.style.transform = "translate(100%, -100%)"
    
    // ハンバーガーアイコンを元に戻す
    this.line1Target.style.transform = "rotate(0deg) translate(0px, 0px)"
    this.line2Target.style.opacity = "1"
    this.line3Target.style.transform = "rotate(0deg) translate(0px, 0px)"
    
    // bodyのスクロールを復元
    document.body.style.overflow = ''
  }

  reset() {
    // 初期状態に戻す（アニメーションなし）
    this.menuTarget.style.transition = "none"
    this.menuTarget.style.transform = "translate(100%, -100%)"
    this.line1Target.style.transform = "rotate(0deg) translate(0px, 0px)"
    this.line2Target.style.opacity = "1"
    this.line3Target.style.transform = "rotate(0deg) translate(0px, 0px)"
    document.body.style.overflow = ''
    
    // 少し遅れてtransitionを復活
    setTimeout(() => {
      this.menuTarget.style.transition = "transform 0.5s ease-in-out"
    }, 10)
  }

  // ウィンドウリサイズ時にPC版に戻った場合の処理
  disconnect() {
    document.body.style.overflow = ''
  }
}